import { useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client/react';
import * as R from 'ramda';

import { GET_BUDGET_TEMPLATES } from '@atom/graph/budget';
import { Button, Icon, IconButton, Select } from '@atom/mui';
import { CloseIcon, EditIcon } from '@atom/mui/icons';
import { BudgetTemplate } from '@atom/types/budget';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import PolicyModalContext from '../PolicyModalContext';

import classes from '../policyModals.module.css';

const { MenuItem } = Select;

const BudgetingUnitTemplateSelection = () => {
  const { data: templatesData, loading: loadingTemplates } =
    useQuery(GET_BUDGET_TEMPLATES);

  const budgetTemplates: BudgetTemplate[] = R.pathOr(
    [],
    ['budgetTemplates', 'budgetTemplates'],
    templatesData,
  );

  const { state, updateState } = useContext(PolicyModalContext);
  const { grants, grantType, budgetUnitTemplateId, loadingExistingPolicies } =
    state;

  // Temporarily selecting the first template returned
  // - This is because there is only one template in the data for the
  //   initial clients. To support multiple templates here will require
  //   adding the budgetTemplateId to the policy data.
  // TODO: https://atomai.atlassian.net/browse/AM-15574
  useEffect(() => {
    const firstTemplateId = budgetTemplates[0]?.id || '';
    updateState({ budgetUnitTemplateId: firstTemplateId });
  }, [budgetTemplates]);

  const handleChange = event => {
    updateState({ budgetUnitTemplateId: event.target.value });
  };

  return (
    <>
      <div className={classes.inputContainer}>
        <Select
          loading={loadingExistingPolicies}
          label="Budget Template"
          value={budgetUnitTemplateId || ''}
          onChange={handleChange}
        >
          {budgetTemplates.map(budgetTemplate => (
            <MenuItem key={budgetTemplate.id} value={budgetTemplate.id}>
              {budgetTemplate.name}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div className={classes.inputContainer}>
        <div className={classes.label}>Budget Unit(s)</div>

        {grants.length ? (
          <div className={classes.tile}>
            {grants.map(({ name }) => name).join(', ')}
            <div className={classes.tile}>
              <IconButton
                size="small"
                onClick={() => updateState({ view: grantType })}
                disabled={loadingExistingPolicies}
              >
                <Icon icon={EditIcon} />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => updateState({ grants: [] })}
                disabled={loadingExistingPolicies}
              >
                <Icon icon={CloseIcon} />
              </IconButton>
            </div>
          </div>
        ) : (
          <Button
            size="small"
            color="primary"
            style={{ minWidth: 0, padding: 0 }}
            onClick={() => updateState({ view: grantType })}
            disabled={
              loadingExistingPolicies ||
              loadingTemplates ||
              isNilOrEmpty(budgetUnitTemplateId)
            }
          >
            Select
          </Button>
        )}
      </div>
    </>
  );
};

export default BudgetingUnitTemplateSelection;
